"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bustStoreCacheIfExpired;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _makeExpiration = _interopRequireDefault(require("../timing/makeExpiration"));

var EXPIRATION = 300000; // 5 minutes

function bustStoreCacheIfExpired() {
  var isExpired = (0, _makeExpiration.default)(EXPIRATION);
  return function deref(props, state, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
        store = _ref2[0];

    return store.get(!isExpired());
  };
}

module.exports = exports.default;